import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from '../../state/signal-entity.store';
import {SuperflowItem} from '../../models/underwriter.model';

export interface SuperflowState extends EntityState<SuperflowItem>{}

export function createInitialState(): SuperflowState {
    return {
        session_id: '',
        superflow_id: 0,
        flow_items: []
    };
}

@Injectable({
    providedIn: 'root'
})
export class SuperflowStore extends SignalEntityStore<SuperflowItem, SuperflowState>{
    constructor() {
        super({name: 'superflow-questions', initialState: createInitialState()});
    }
}
